import { remapForSpace } from '@src/libs/utils/mapSpaceItem';

const getSpacesForSpace = (items) => items.map(remapForSpace);

export default getSpacesForSpace;
